"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}

function _asyncToGenerator(fn) {
    return function () {
        var self = this, args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
        });
    };
}

/**
 * Directive de formulaire pour l'ajout d'une intervention
 */
app.directive('formAddIntervention', ['crudService', '$filter', '$rootScope', '$stateParams', 'userPrefService', function (crudService, $filter, $rootScope, $stateParams, userPrefService) {
    return {
        restrict: "E",
        templateUrl: "/templates/partials/directives/forms/intervention/add_intervention.html",
        scope: {
            siteid: '=',
            // ID du site en cours
            contratid: '=',
            // ID du contrat en cours
            categoryid: '=',
            // ID de la category / mission : charge des produit uniquement pour cette categ
            produitid: '=',
            // ID du produit : a associer à la future intervention
            urlsubmit: '=',
            // URL pour la création de l'intervention
            produitnom: '=?' // Nom du produit

        },
        link: function link(scope, element, attrs, tabsCtrl) {
            scope.messages_error = []; // Erreurs formulaire

            scope.editMode = false; // Mode edit

            scope.inter_id = null; // ID de l'intervention à éditer

            scope.submit_loaded = true; // formulaire chargé : false = en cours de chargement

            scope.produit_loaded = true; // dropdown produit en chargement

            scope.produit_id_selected = null; // ID produit selectionné

            scope.collaborateurs_loaded = true; // Loader chargement dropdown collaborateurs
            scope.showIntervenantAutres = false;
            scope.productsWithoutInterventions = ['premiers_secours'];
            scope.globalView = $stateParams.product_id === "" || $stateParams.product_id === undefined || $stateParams.product_id === null; // Vu de tous les produits / Vue par produit

            /**
             * Détruit les signaux déjà existant
             */

            $rootScope.destroySignals(['DirectiveAddInter::setCurrentInter', 'DirectiveAddInter::setEditMode', 'DirectiveAddInter::setProduit', 'DirectiveAddInter::resetMsgError']);
            /**
             * Listener lors du clique sur le bouton editer une intervention
             */

            $rootScope.$on('DirectiveAddInter::setCurrentInter', function (e, data) {
                scope.urlEditInter = data.url; // URL dédition de l'intervention

                scope.currentInter = data.currentInter; // Données de l'intervention

                scope.inter_id = scope.currentInter.inter_id; // ID Intervention sélectionnée

                setTimeout(function () {
                    $('#produit-dropdown') // Produits
                        .dropdown('set selected', scope.currentInter.inter_produit).dropdown('refresh');
                    $('#collaborateur-dropdown') // Intervenants
                        .dropdown('set selected', scope.currentInter.intervenant_id).dropdown('refresh');
                }, 0);
                var date = new Date(scope.currentInter.inter_date);
                var day = date.getDate();
                var month = date.getMonth() + 1;
                var year = date.getFullYear();
                $('#interDate').val((day > 9 ? '' : '0') + day + '-' + ((month > 9 ? '' : '0') + month) + '-' + year);

                $('#interCommentaire').val(scope.currentInter.inter_commentaire); // Commentaire
                if(scope.showIntervenantAutres == 1) {
                    $('#collaborateur_autre').val(scope.currentInter.collaborateur_autre);
                }

                $('#interReserves').val(scope.currentInter.reserves); // Reserves
            });
            /**
             * Listener qui change le mode (ajout / edition)
             */

            $rootScope.$on('DirectiveAddInter::setEditMode', function (e, data) {
                scope.editMode = data.editMode; // True => Edition, False => Ajout
            });
            /**
             * Listener qui change le produit
             */

            $rootScope.$on('DirectiveAddInter::setProduit', function (e, data) {
                scope.produitid = data.produitid; // ID du produit

                scope.produitnom = data.produitNom; // Nom du produit
                scope.registerChapId = data.registerChapId; // Nom du produit

                initCollaborateursDropdown(true);
                initProduits();
            });
            /**
             * Init de la dropdown produit si necessaire
             * @return void
             */

            scope.choosenProduct = null;

            var initDropdownProduits = function initDropdownProduits() {
                $('#produit-dropdown').dropdown({
                    onChange: function onChange(value, text, $choice) {
                        if (scope.globalView && !scope.editMode && text !== undefined) {
                            scope.choosenProduct = $filter('slugify')(text);
                            scope.$apply();
                        }

                        scope.produit_id_selected = value;
                    }
                });
            };
            /**
             * Renvoi l'url de base du contrat
             */


            var getContratUrl = function getContratUrl() {
                return 'contrat/' + scope.contratid + '/security_register/site/' + scope.siteid;
            };
            /**
             * Init des données de la dropdown produit si necessaire
             * @return Boolean|void
             */


            var initProduits = function initProduits() {
                scope.produit_id_selected = null;

                if (angular.isUndefined(scope.contratid) && scope.contratid != '' && scope.produitid !== null && scope.produitid !== undefined) {
                    return false;
                }

                var params = {
                    category_id: scope.categoryid
                };
                scope.produit_loaded = false; // Recuperation et bind de la dropdown produits

                crudService.get('contrat/' + scope.contratid + '/products-by-categ', params).then(function (response) {
                    scope.allCategsAndProducts = response;
                    setDropdownProduits();
                    initDropdownProduits();
                    scope.produit_loaded = true;
                });
            };

            var setDropdownProduits = function setDropdownProduits() {
                $('#produit-dropdown .menu').html('');
                angular.forEach(scope.allCategsAndProducts, function (categData, categName) {
                    $('#produit-dropdown .menu').append('<div class="ui horizontal divider">' + $filter('translate')(categName) + '</div>');
                    angular.forEach(categData, function (produit, key) {
                        if (!scope.editMode || produit.nom !== 'instruction_du_personnel' && produit.nom !== 'formation_du_personnel' && produit.nom !== 'enregistrement_des_incidents') {
                            if (scope.productsWithoutInterventions.indexOf(produit.nom) === -1) {
                                $('#produit-dropdown .menu').append('<div class="item" data-value="' + produit.id + '">' + $filter('translate')(produit.nom) + '</div>');
                            }
                        }
                    });
                });
            };

            scope.collaborateurDropdownLoading = false; // Flag évitant le répétition des prestataires dans la dropdown


            var initCollaborateursDropdown = function initCollaborateursDropdown(sendSignal) {
                    if (!scope.collaborateurDropdownLoading) {
                        scope.collaborateurs_loaded = false;
                        scope.collaborateurDropdownLoading = true;
                        $('#collaborateur-dropdown .menu').html('');

                        crudService.get('site/' + scope.siteid + '/recipient', {
                            'groupby_entreprise': true
                        }).then(function (response) {
                            if (angular.isDefined(response.recipients)) {
                                angular.forEach(response.recipients, function (entreprise, key) {
                                    $('#collaborateur-dropdown .menu').append('<div class="ui horizontal divider">' + key + '</div>');
                                    angular.forEach(entreprise, function (user, key) {
                                        $('#collaborateur-dropdown .menu').append('<div class="item" data-value="' + user.id + '">' + user.nom + ' ' + user.prenom + '</div>');
                                    });
                                });
                                $('#collaborateur-dropdown').dropdown();
                            }

                            if(
                                scope.produitid !== null
                                && scope.produitid !== undefined
                            ) {
                                crudService.get('contrat/' + scope.contratid + '/product/' + scope.produitid + '/is-special-register-chapter').then(function (response) {
                                    if (angular.isDefined(response.specialfield)) {
                                        if (response.specialfield == 1) {
                                            scope.showIntervenantAutres = true;
                                        }
                                    }
                                });
                            }

                            if (sendSignal) {
                                $rootScope.$broadcast('DirectiveAddInter::collaborateursLoaded', {
                                    loaded: true
                                });
                            }

                            scope.collaborateurs_loaded = true;
                            scope.collaborateurDropdownLoading = false;
                        });
                    }
                }
            ;

            scope.init = function () {
                initCollaborateursDropdown();
            };

            scope.init();
            /**
             * Format serializeArray pour req POST
             * @param  Array formArray serializeArray
             * @return Object
             */

            var formatArrayForm = function formatArrayForm(formArray) {
                var data = {};

                for (var i = 0; i < formArray.length; i++) {
                    var item = formArray[i];
                    data[item['name']] = item['value'];
                }

                data['date'] = new Date(data['date']);
                return data;
            };
            /**
             * Renvoi le bon label pour l'input intervenant
             */

            scope.getIntervenantLabel = function () {
                var label = "";

                if (scope.produitnom === "instruction_du_personnel" || scope.choosenProduct === "instruction_du_personnel") {
                    label = $filter('translate')('instructeur');
                } else if (scope.produitnom === 'formation_du_personnel' || scope.choosenProduct === 'formation_du_personnel') {
                    label = $filter('translate')('formateur');
                } else {
                    label = $filter('translate')('intervenant');
                }

                return label;
            };

            scope.getIntervenantLabelAutres = function () {
                var label = "";

                if (scope.produitnom === "instruction_du_personnel" || scope.choosenProduct === "instruction_du_personnel") {
                    label = $filter('translate')('instructeur autres');
                } else if (scope.produitnom === 'formation_du_personnel' || scope.choosenProduct === 'formation_du_personnel') {
                    label = $filter('translate')('formateur autres');
                } else {
                    label = $filter('translate')('intervenant autres');
                }

                return label;
            };

            /**
             * Renvoi le bon label pour l'input commentaire
             */


            scope.getCommentaireLabel = function () {
                var label = "";

                if (scope.produitnom === 'instruction_du_personnel' || scope.produitnom === 'formation_du_personnel' || scope.choosenProduct === 'instruction_du_personnel' || scope.choosenProduct === 'formation_du_personnel') {
                    label = $filter('translate')('participants');
                } else if (scope.produitnom === 'enregistrement_des_incidents' || scope.choosenProduct === 'enregistrement_des_incidents') {
                    label = $filter('translate')('actions_correctives');
                } else {
                    label = $filter('translate')('observations');
                }

                return label;
            };
            /**
             * Renvoi le bon label pour l'input reserves
             */


            scope.getReservesLabel = function () {
                var label = '';

                if (scope.produitnom === 'instruction_du_personnel' || scope.choosenProduct === 'instruction_du_personnel') {
                    label = $filter('translate')('type_instruction');
                } else if (scope.produitnom === 'formation_du_personnel' || scope.choosenProduct === 'formation_du_personnel') {
                    label = $filter('translate')('type_formation');
                } else if (scope.produitnom === 'enregistrement_des_incidents' || scope.choosenProduct === 'enregistrement_des_incidents') {
                    label = $filter('translate')('nature_de_lincident');
                }

                return label;
            };
            /**
             * Affiche l'intervenant ou non
             */


            scope.showIntervenant = function () {
                return scope.produitnom !== 'enregistrement_des_incidents'
                    && scope.choosenProduct !== 'enregistrement_des_incidents'
                    && scope.choosenProduct !== 'plan_evacuation'
                    && scope.produitnom !== 'plan_evacuation'
                    ;
            };

            scope.showLocalisation = function () {
                return scope.produitnom === 'plan_evacuation' || scope.choosenProduct === 'plan_evacuation';
            };

            /**
             * Affiche le deuxième textarea ou non
             */


            scope.showExtraContent = function () {
                return scope.produitnom === 'instruction_du_personnel' || scope.produitnom === 'formation_du_personnel'
                    || scope.produitnom === 'enregistrement_des_incidents' || scope.choosenProduct === 'instruction_du_personnel'
                    || scope.choosenProduct === 'formation_du_personnel' || scope.choosenProduct === 'enregistrement_des_incidents';
            };
            /** Au submit
             * @return void
             */


            scope.onSubmit =
                /*#__PURE__*/
                _asyncToGenerator(
                    /*#__PURE__*/
                    regeneratorRuntime.mark(function _callee() {
                        var inputsArray, dateIndex, inputs, url;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        scope.submit_loaded = false;
                                        scope.messages_error = [];

                                        if (!(angular.isDefined(scope.urlsubmit) || angular.isDefined(urlEditInter))) {
                                            _context.next = 13;
                                            break;
                                        }

                                        inputsArray = $('form', element).serializeArray();
                                        dateIndex = inputsArray.findIndex(function (x) {
                                            return x.name == "date";
                                        });

                                        if (!(inputsArray[dateIndex]['value'].length > 0)) {
                                            _context.next = 9;
                                            break;
                                        }

                                        _context.next = 8;
                                        return this.dateFormat(inputsArray[dateIndex]['value']);

                                    case 8:
                                        inputsArray[dateIndex]['value'] = _context.sent;

                                    case 9:
                                        inputs = formatArrayForm(inputsArray);
                                        url = scope.editMode ? scope.urlEditInter : scope.urlsubmit;
                                        _context.next = 13;
                                        return crudService.post(url, inputs, {
                                            error_code_ignore_modal: [500]
                                        }).then(function (response) {
                                            if (scope.editMode) {
                                                // Si mode edit
                                                var newYear = new Date(inputs['date']).getFullYear(); // Année de l'intervention modifiée

                                                var currentYear = new Date().getFullYear(); // Année actuelle

                                                var bottomFilterYears = []; // Tableau final d'update des années du bottom filter

                                                var exerciceArray = null; // Exercices des interventions du site

                                                var bottomFilterArray = null; // Années cochées dans le bottom filter

                                                crudService.get(getContratUrl() + '/get-inter-years').then(function (responseExe) {
                                                    // Récupération des exercices des interventions
                                                    exerciceArray = responseExe; // Exercices

                                                    if (Array.isArray(exerciceArray) && exerciceArray.length > 0) {
                                                        // Si le tableau contient au moins un exercice
                                                        userPrefService.get('bottom_filter', 'years').then(function (responseBottom) {
                                                            // Récupération des années du bottom filter
                                                            bottomFilterArray = responseBottom; // Années

                                                            if (Array.isArray(bottomFilterArray) && bottomFilterArray.length > 0) {
                                                                // Si il y a une année cochée
                                                                angular.forEach(bottomFilterArray, function (year) {
                                                                    // Pour chaque année du bottom filter
                                                                    if (exerciceArray.indexOf(year) !== -1 || parseInt(year) - currentYear <= 5 && parseInt(year) - currentYear >= 0) {
                                                                        // Si cette année est présente dans le tableau des exerices ou si l'année est maximum 5 ans de plus que l'année acutelle
                                                                        bottomFilterYears.push(year.toString()); // Ajout au tableau de mise à jour du bottom filter
                                                                    }
                                                                });

                                                                if (bottomFilterYears.indexOf(newYear.toString()) === -1) {
                                                                    bottomFilterYears.push(newYear.toString()); // Ajout au tableau de mise à jour du bottom filter
                                                                }

                                                                userPrefService.set('bottom_filter', 'years', bottomFilterYears).then(function (response) {
                                                                    // Mise à jour du filtre année en base
                                                                    $rootScope.$broadcast('BottomFilter::refreshYears', {
                                                                        contratId: scope.contratid
                                                                    }); // Rafraîchissement des années du bottom filter

                                                                    scope.submit_loaded = true; // Fin loader

                                                                    $rootScope.$broadcast('form_add_intervention_done', response); // Fermeture de la modal
                                                                });
                                                            } else {
                                                                scope.submit_loaded = true; // Fin loader

                                                                $rootScope.$broadcast('form_add_intervention_done', response); // Fermeture de la modal
                                                            }
                                                        });
                                                    } else {
                                                        scope.submit_loaded = true; // Fin loader

                                                        $rootScope.$broadcast('form_add_intervention_done', response); // Fermeture de la modal
                                                    }
                                                });
                                            } else {
                                                scope.submit_loaded = true; // Fin loader

                                                $rootScope.$broadcast('form_add_intervention_done', response); // Fermeture de la modal
                                            }
                                        }, function (error) {
                                            scope.submit_loaded = true;

                                            if (angular.isDefined(error.data) && angular.isDefined(error.data.messages)) {
                                                scope.messages_error = error.data.messages;
                                            }
                                        });

                                    case 13:
                                    case "end":
                                        return _context.stop();
                                }
                            }
                        }, _callee, this);
                    }));
            /**
             * format une date FR en US
             * @param date
             * @returns {string}
             */

            scope.dateFormat = function (date) {
                var splitDate = date.split('-');
                var year = splitDate[2];
                var month = splitDate[1];
                var day = splitDate[0];
                return year + '-' + month + '-' + day;
            };
            /**
             * Au clic sur le btn annuler
             * @return void
             */


            scope.onCancel = function () {
                // reset form
                $('input[type="text"]', element).val('');
                $('textarea', element).val('');
                $('#collaborateur-dropdown').dropdown('restore defaults');
                $rootScope.$broadcast('form_add_intervention_cancel', {});
            };
            /**
             * Reset le message d'erreur
             */


            $rootScope.$on('DirectiveAddInter::resetMsgError', function (e, data) {
                if (data.reset) {
                    scope.messages_error = [];
                }
            });
        }
    };
}]);